import { useMemo } from 'react';

import { DatesRangeUtils } from '@any-ui-react/dates';

import {
  AdsMetricsType,
  ReportChartTab,
  ReportDimensions,
  ReportOrderStatus,
  ReportTab,
} from '@anyx/common-graphql';
import { HomeMetricOption, useReportSyncCalendar } from '@anyx/feature-report';
import { DateUtils, TimezoneUtils, useFilters } from '@anyx/shared-utils';

import { HomeFilterInputFilterType, HomePageFiltersParser } from './homePage.filters';

export const useHomeFilter = ({
  accountIds,
  storeId,
}: {
  accountIds: string[];
  storeId?: string;
}) => {
  const timezone = TimezoneUtils.getCurrentTimezone();

  const { range } = useReportSyncCalendar();

  const filtersDefault = useMemo(
    () =>
      HomePageFiltersParser.parse({
        startDate: range?.startDate ?? DatesRangeUtils(timezone).LAST_7_DAYS.start.toISOString(),
        endDate: range.endDate ?? DatesRangeUtils(timezone).LAST_7_DAYS.end.toISOString(),
        orderStatus: ReportOrderStatus.ORDERED,
        masterDataAccountIds: accountIds,
        masterDataStoreIds: storeId ? [storeId] : [],
        marketplaces: [],
        dimensions: ReportDimensions.DAY,
        metric: HomeMetricOption.GROSS_SALES,
        adsMetricsType: AdsMetricsType.GROSS,
        chartTab: ReportChartTab.CHANNEL,
        tab: ReportTab.ALL,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [timezone, storeId]
  );

  const filters = useFilters<HomeFilterInputFilterType>(filtersDefault, {
    withPagination: false,
    withLocalStorage: false,
    scope: 'home',
    parser: HomePageFiltersParser.parse,
  });

  const dateVariables = {
    endDate: filters.current?.endDate
      ? DateUtils.formatDateInTimeZone(filters.current?.endDate, { formatStr: '' })
      : '',
    startDate: filters.current?.startDate
      ? DateUtils.formatDateInTimeZone(filters.current?.startDate, { formatStr: '' })
      : '',
  };

  const filterInputs = {
    ...filters.current,
    ...dateVariables,
  };

  return {
    filters,
    filterInputs,
  };
};
